<template>
  <div
    class="bg-background-neutral-secondary flex flex-col space-y-4 rounded-2xl p-3"
    :class="{
      'pt-6': hasLabel,
    }"
  >
    <div class="flex space-x-3">
      <picture>
        <source srcset="./assets/roaming.webp" type="image/webp" />
        <img
          src="./assets/roaming.png"
          width="56"
          height="56"
          alt=""
          role="presentation"
        />
      </picture>
      <div class="mb-1 flex w-full flex-1 items-start justify-between">
        <div>
          <p class="text-text-neutral-primary text-base font-semibold">
            {{ roamingProduct.title }}
          </p>
          <p class="text-text-neutral-secondary text-sm">
            {{ roamingProduct.short_description }}
          </p>
        </div>
        <button type="button" @click="emit('onShowRoamingInfo')">
          <InfoIcon />
        </button>
      </div>
    </div>
    <FreeButton
      type="button"
      class="w-full"
      size="sm"
      :class="isSelected ? 'gray-button' : 'green-main-button'"
      @click="emit('onProductToggle')"
    >
      {{ isSelected ? $t('general.delete') : $t('general.add') }}
    </FreeButton>
  </div>
</template>

<script setup lang="ts">
  import type { Airflow } from '@aviata/platform-types';
  import { FreeButton } from 'freedom-shared';

  import InfoIcon from '@/assets/images/product-details-icon.svg?component';

  defineProps<{
    roamingProduct: Airflow.Products.GenericProduct;
    isSelected?: boolean;
    hasLabel?: boolean;
  }>();

  const emit = defineEmits<{
    onShowRoamingInfo: [];
    onProductToggle: [];
  }>();
</script>
